<template>
  <div>
    <div id="show-table">
      <table class="table table-hover table-show" :class="{minheight: isActive}">
        <caption id="table-title">
          <ul class="list-basic-settings">
            <li v-for="(item,index) in captionTitle" @click="toggle(index)" :class="{nativeLi: active == index}">{{ item
              }}
              <div v-if=""></div>
            </li>
            <li id="time-li">
              <select name="" id="">
                <option value="">发布时间</option>
              </select>
            </li>
          </ul>
        </caption>
        <tbody>
        <template v-if=" infos != '' ">
          <tr v-for="info in infos" class="tr-height" @click="seeDetails(info)">
            <template v-if=" dataType==='招标公告' || dataType==='询价公告'">
              <template v-if="info.status">
                <td width="15%">
                  <template v-if=" info.status==='1' ">
                    <span class="state state-bid">未开始</span>
                  </template>
                  <template v-else-if=" info.status==='3' ">
                    <span class="state state-enquiry">已结束</span>
                  </template>
                  <template v-else>
                    <span class="state state-bidding">进行中</span>
                  </template>
                </td>
              </template>
              <template v-else>
                <td width="15%">
                  <template v-if=" now < timeFormat(info.publishTime) ">
                    <span class="state state-bid">未开始</span>
                  </template>
                  <template v-else-if=" now > timeFormat(info.deadline) ">
                    <span class="state state-enquiry">已结束</span>
                  </template>
                  <template v-else>
                    <span class="state state-bidding">进行中</span>
                  </template>
                </td>
              </template>
              <td width="25%" class="limitText" :title="info.messageTitle">
                <div>{{info.messageTitle}}</div>
              </td>
              <td width="30%" class="limitText limitContent" :title="info.messageContent">
                <div>{{info.messageContent}}</div>
              </td>
              <td width="30%">
                <span class="pull-right">截止时间：{{info.deadline | cutStr}}</span>
              </td>
            </template>
            <template v-else-if=" dataType==='中标公告' ">
              <td width="70%" class="limitText limitContent2" :title="info.messageContent">
                <div>{{info.messageContent}}</div>
              </td>
              <td width="30%">
                <span class="pull-right">发布时间：{{info.publishTime | cutStr}}</span>
              </td>
            </template>
          </tr>
        </template>
        <template v-else>
          <p class="error-handling">暂无数据</p>
        </template>
        </tbody>
      </table>
    </div>
    <div id="paging" class="pull-right" v-show="isActive == false">
      <nav>
        <ul class="pagination">
          <li :class="{disabled: disabled[0]}" @click="pageUp()"><a href="javascript:;">&laquo;</a></li>
          <!--<li v-for="n in pagesNum" @click="turnPage(n)"><a-->
          <!--href="javascript:;" :class="{currentPage: currentPage == n}">{{ n }}</a>-->
          <!--</li>-->
          <li v-for="(item,index) in pagingContent">
            <template v-if="item">
              <span v-html="item" :class="{currentPage: currentPage == index+1}" @click="turnPage(index+1,item)"></span>
            </template>
          </li>
          <li :class="{disabled: disabled[1]}" @click="pageDown()"><a href="javascript:;">&raquo;</a></li>
        </ul>
      </nav>
      <p>
        共{{ pagesNum }}页 &nbsp;&nbsp;到第 <input id="pagesNum" class="whichPage" type="number" :max="pagesNum"
      > 页
        <button id="turnPage" @click="btnTurnPage()">确定</button>
      </p>
    </div>
  </div>
</template>

<script>
  import {apiLinks} from '../api/links.js'
  import Bus from '../eventbus/bus'
  import EVENTLIST from '../eventbus/eventlist'

  export default {
    name: 'showtable',
    props: {
      captionTitle: '',
      condition: '',
      dataUrl: '',
      activeIndex: ''
    },
    data () {
      return {
        //tab选项卡的展示内容index
        active: 1,
        //得到的数据
        infos: '',
        url: '',
        isActive: true,
        //数据总页数
        pagesNum: '',
        //当前页
        currentPage: 1,
        //当前页面的url
        currentPageUrl: this.dataUrl[1],
        record: this.dataUrl[1],
        disabled: [
          true,
          false
        ],
        dataType: '招标公告',
        now: new Date().getTime(),
        pagingContent: []
      }
    },
    created: function () {
      switch (this.activeIndex) {
        case 0:
          this.active = this.activeIndex
          break
        default:
          break
      }
      // 根据传值判断是哪个页面的table数据
      let array = window.location.href.split('?')
      if (array.length > 1) {
        let index = parseInt(array[1].split('=')[1])
        switch (index) {
          case 0:
            this.dataType = '询价公告'
            break
          case 1:
            this.dataType = '招标公告'
            break
          case 2:
            this.dataType = '中标公告'
            break
          default:
            this.dataType = ''
            break
        }
        //if (index === 1) {
        //  this.dataType = '招标公告'
        //} else if (index === 2) {
        //  this.dataType = '中标公告'
        //} else {
        //  this.dataType = ''
        //}
        this.active = index
        this.currentPageUrl = this.dataUrl[index]
      }
      if (this.currentPageUrl !== '') {
        var pathArr = window.location.pathname.split('/');
        if(pathArr[pathArr.length - 1] == 'deal.html'){
          //竞买竞卖
          this.getCustomers(this.dataUrl[0])
        }else{
          this.getCustomers(this.currentPageUrl)
        }
      }
    },
    filters: {
      cutStr: function (str) {
        if (!str) return ''
        let abortDate = ''
        abortDate = str.split('-')
        let abortDay = ''
        abortDay = abortDate[abortDate.length - 1].split(' ')
        return abortDate[0] + '年' + abortDate[1] + '月' + abortDay[0] + '日'
      },
      timeNum: function (str) {
        // v-if里面不能使用过滤器？没有用到这个过滤器
        if (!str) return ''
        return new Date(str).getTime()
        //let t = Date.parse(str)
        //if (!isNaN(t)) {
        //  return new Date(Date.parse(str.replace(/-/g, '/'))).getTime()
        //} else {
        //  return ''
        //}
      }
    },
    methods: {
      nowUrl: function () {
        this.url = window.location.href
      },
      toggle: function (index) {
        //index = parseInt(index)
        this.currentPage = 1

        var pathArr = window.location.pathname.split('/');
        if(pathArr[pathArr.length - 1] == 'deal.html'){
          //竞卖竞卖
          switch (index) {
            case 0:
              this.dataType = '招标公告'
              break
            case 1:
              this.dataType = '中标公告'
              break
            default:
              this.dataType = ''
              break
          }
        } else {
          switch (index) {
            case 0:
              this.dataType = '询价公告'
              break
            case 1:
              this.dataType = '招标公告'
              break
            case 2:
              this.dataType = '中标公告'
              break
            default:
              this.dataType = ''
              break
          }
        }
        
        this.currentPageUrl = this.dataUrl[index]
        this.record = this.dataUrl[index]
        this.active = index
        if (this.dataUrl[index] !== '') {
          this.getCustomers(this.currentPageUrl)
        } else {
          this.isActive = true
          this.infos = ''
        }
        Bus.$emit(EVENTLIST.TODO_CHANGE)
      },
      getCustomers: function (url) {
        this.$http.jsonp(url, []).then(function (response) {
          if (response.data[0]['result'].length) {
            this.infos = response.data[0]['result']
            this.pagesNum = response.data[0].totalPage
            this.pagingConstruct(this.currentPage)
          } else {
            this.infos = ''
            this.isActive = true
          }
          if (this.infos !== '') {
            this.isActive = false
          }
          if (this.currentPage < 1 || this.currentPage === 1) {
            this.disabled[0] = true
          } else {
            this.disabled[0] = false
          }
          if (this.currentPage > this.pagesNum || this.currentPage === this.pagesNum) {
            this.disabled[1] = true
          } else {
            this.disabled[1] = false
          }
        }, function (response) {
          console.log(0)
        })
      },
      judgeCurrentPage: function (index) {
        let str = this.currentPageUrl
        let array = str.split('pageIndex=')
        str = array[0] + 'pageIndex=' + (index - 1)
        console.log(str)
        this.currentPageUrl = str
        this.getCustomers(this.currentPageUrl)
      },
      btnTurnPage: function () {
        let value = parseInt(document.getElementById('pagesNum').value)
        if (value > this.pagesNum) {

        } else if (value < 1) {

        } else {
          this.currentPage = value
          this.judgeCurrentPage(this.currentPage)
        }
        document.getElementById('pagesNum').value = ''
      },
      turnPage: function (index, item) {
        if (item.length > 30) {
          this.currentPage = index
          this.judgeCurrentPage(this.currentPage)
        }
      },
      pageUp: function () {
        if (this.currentPage > 1) {
          console.log('向上翻页')
          this.currentPage--
          console.log(this.currentPage)
          this.judgeCurrentPage(this.currentPage)
        }
      },
      pageDown: function () {
        if (this.currentPage < this.pagesNum) {
          console.log('向下翻页')
          this.currentPage++
          console.log(this.currentPage)
          this.judgeCurrentPage(this.currentPage)
        }
      },
      seeDetails: function (info) {
        let url = ''
        var status = info.messageType
        if(info.messageType == '中标通知' && info.messageTypeShow == '17'){
          url = apiLinks.details['bidauctionNotice'] + info.msgId
          window.open(url)
          return false
        }
        switch (status) {
          case '招标':
            url = apiLinks.details['bidDoc'] + info.msgId
            break
          case '询价':
            url = apiLinks.details['inquiryDetails'] + info.msgId
            break
          case '招标公告':
            url = apiLinks.details['bidDetails'] + info.msgId
            break
          case '中标通知':
            url = apiLinks.details['bidNotice'] + info.msgId
            break
          case '竞价公告':
            url = apiLinks.details['jingjia'] + info.msgId
            break
          default:
            break
        }
        if (url !== '') {
          window.open(url)
        }
      },
      timeFormat: function (str) {
      //只有谷歌火狐识别'/'时间格式
        return new Date(Date.parse(str.replace(/-/g, '/'))).getTime()
      },
      pagingConstruct: function (paging) {
        this.pagingContent = []
        //这里是加载省略号的flag
        let isHiddenExist = 0
        //从第1页读到第max页。
        for (let i = 1; i <= this.pagesNum; i++) {
        //如果是页首，中间页，页尾，当前页的前后三页则不省略。
          let item
          switch (paging) {
            case 1:
              if (i < 4) {
                item = `<a href='javascript:;' title="点击进行翻页"> ${i}</a>`
                isHiddenExist = 0
              } else {
                if (isHiddenExist === 0) {
                  item = "<a href='javascript:;'>...</a>"
                  isHiddenExist = 1
                }
              }
              break
            case this.pagesNum:
              if (i > (this.pagesNum - 3)) {
                item = `<a href='javascript:;' title="点击进行翻页"> ${i}</a>`
                isHiddenExist = 0
              } else {
                if (isHiddenExist === 0) {
                  item = "<a href='javascript:;'>...</a>"
                  isHiddenExist = 1
                }
              }
              break
            default:
              if (i < (paging + 2) && i > (paging - 2)) {
                item = `<a href='javascript:;' title="点击进行翻页"> ${i}</a>`
                isHiddenExist = 0
              } else {
                if (isHiddenExist === 0) {
                  item = "<a href='javascript:;'>...</a>"
                  isHiddenExist = 1
                }
              }
              break
          }
        //if (i < (paging + 2) && i > (paging - 2)) {
        //  item = `<a href='javascript:;' title="点击进行翻页"> ${i}</a>`
        //  isHiddenExist = 0
        //} else {
        //  if (isHiddenExist === 0) {
        //    item = "<a href='javascript:;'>...</a>"
        //    isHiddenExist = 1
        //  }
        //}
          this.pagingContent.push(item)
        }
      }
    },
    watch: {
      condition: function (newQuestion) {
        if (this.condition !== '') {
          let str = this.record
          let array = str.split('?')
          //materialClassIds=&
          str = array[0] + '?innercode=' + this.condition + '&' + array[1]
          this.currentPageUrl = str
          this.getCustomers(this.currentPageUrl)
        } else {
          this.currentPageUrl = this.record
          this.getCustomers(this.currentPageUrl)
        }
        this.currentPage = 1
      }
    }
  }
</script>


<style>
  .nativeLi {
    border-bottom: none !important;
    border-top: 3px solid #EB5559 !important;
    /*position: relative;*/
    /*top: 1px;*/
    overflow: visible;
    position: relative;
    /*z-index: 99;*/
  }

  .nativeLi > div {
    /*z-index: 2;*/
    position: absolute;
    top: 35px;
    left: 0px;
    width: 98px;
    height: 3px;
    background-color: #ffffff;
  }

  .minheight {
    min-height: 398px;
  }

  .table-show > tbody {
    border: 1px solid #DEDEDE;
    /*border-top: none;*/
  }

  .error-handling {
    margin-top: 150px;
    text-align: center;
  }

  .state {
    display: inline-block;
    padding: 0 8px;
    /*height: 20px;*/
    text-align: center;
  }

  .state-bid {
    border: 1px solid #92B8E0;
    color: #639cd7;
  }

  .state-enquiry {
    border: 1px solid #FD9B31;
    color: #F58000;
  }

  .state-bidding {
    border: 1px solid #F15A4A;
    color: #F15A4A;
  }

  .state-other {
    border: 1px solid #CC9999;
    color: #CC9999;
  }

  .limitText {
    white-space: nowrap;
    /*显示省略符号来代表被修剪的文本*/
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    overflow: hidden;
  }

  .limitText > div {
    width: 80%;
    white-space: nowrap;
    /*显示省略符号来代表被修剪的文本*/
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    overflow: hidden;
  }

  .limitContent > div {
    width: 250px;
  }

  .limitContent2 > div {
    width: 500px;
  }

  .tr-height {
    height: 40px;
    cursor: pointer;
  }

  .tr-height > td:nth-child(1) {
    padding-left: 20px;
  }

  .tr-height > td:last-child {
    padding-right: 20px;
  }

  /*翻页*/
  #paging > nav {
    display: inline-block;
  }

  #paging > nav a {
    color: #666666;
  }

  #paging > p {
    display: inline-block;
    margin-left: 10px;
    position: relative;
    top: -32px;
  }

  #paging li > span {
    cursor: pointer;
  }

  .whichPage {
    border: 1px solid #ccc;
    height: 25px;
    width: 40px;
    text-align: center;
  }

  #turnPage {
    width: 56px;
    height: 30px;
    background-color: #F7F7F7;
    border: 1px solid #E8E8E8;
    border-radius: 4px;
    position: relative;
    top: -1px;
    color: #333333;
  }

  /*当前页的样式*/
  .current-page {
    border: 1px solid #F15A4A;
    color: #E84C3D;
  }

  #time-li {
    opacity: 0;
  }

  .currentPage {
    background-color: #eeeeee !important;
  }

  .pagination > li > a:focus:first-child {
    background-color: #fff;
  }

  .pagination > li > a:focus:last-child {
    background-color: #fff;
  }

  .pagination > li > a:hover:first-child {
    background-color: #eeeeee;
  }

  .pagination > li > a:hover:last-child {
    background-color: #eeeeee;
  }

  /*.notice-content{*/

  /*}*/

  #show-table {
    min-height: 441px;
  }
</style>



// WEBPACK FOOTER //
// show-table.vue?b2482c00